import { Inject, Injectable } from '@angular/core';
import { getId, sameId } from '@cawita/core-front';
import { Socket } from 'ngx-socket-io';
import { Subject } from 'rxjs';
import { CWT_APP_CONFIG, CwtAppConfig } from '@mobile/modules/core/core-app.config';
import { SocketListener } from '../socket/socket-listener';
import { StayListener } from '../stay/stay-listener';
import { Announcement, Partner } from '@shared/models';

@Injectable({ providedIn: 'root' })
export class AnnouncementSocket implements SocketListener, StayListener {

  private _loggedIn = false;
  private _joined = false;
  private _currentPartnerId: string;

  private _onAnnouncement = new Subject<Announcement>();
  public readonly onAnnouncement = this._onAnnouncement.asObservable();

  constructor(
    @Inject(CWT_APP_CONFIG) private config: CwtAppConfig,
    private socket: Socket
  ) {
    this.socket.on('announcement', (announcement) => this._onAnnouncement.next(new Announcement(announcement)))
  }

  onSocketConnected(): void {
    this._loggedIn = true;
    this._tryJoin();
  }
  onSocketLoggedOut(): void {
    this._loggedIn = false;
    this._joined = false;
  }

  onPartnerActivated(partner: Partner) {
    if (this._currentPartnerId && !sameId(this._currentPartnerId, partner)) this._tryLeave();
    this._currentPartnerId = getId(partner);
    this._tryJoin();
  }

  private _tryLeave() {
    if (!this._loggedIn) return;
    if (!this._joined) return;
    if (!this._currentPartnerId) return;
    this.socket.emit('leave', { room: `/announcement/${getId(this._currentPartnerId)}` }, () => {
      this._joined = false;
      console.log('LEFT ANNOUNCEMENT ROOM');
    });
  }

  private _tryJoin() {
    if (!this._loggedIn) return;
    if (this._joined) return;
    if (!this._currentPartnerId) return;

    console.log('SENDING JOIN');
    this.socket.emit('join', { room: `/announcement/${getId(this._currentPartnerId)}` }, () => {
      this._joined = true;
      console.log('JOINED ANNOUNCEMENT ROOM');
    })
  }
}